const coordinatePair = (value) => {
  const parts = Array.isArray(value)
    ? value
    : (typeof value === 'string' ? value.trim().split(/[\s,;]+/) : []);

  if (parts.length < 2 || parts.some((part) => Array.isArray(part) || (part && typeof part === 'object'))) {
    return null;
  }

  const longitude = Number(parts[0]);
  const latitude = Number(parts[1]);
  return Number.isFinite(longitude) && Number.isFinite(latitude)
    ? [longitude, latitude]
    : null;
};

const normalizeCoordinates = (coordinates) => {
  const pair = coordinatePair(coordinates);
  if (pair) return pair;
  if (!Array.isArray(coordinates)) return null;

  const normalized = coordinates
    .map(normalizeCoordinates)
    .filter((item) => item !== null);
  return normalized.length ? normalized : null;
};

const normalizeGeometry = (geometry) => {
  if (!geometry || typeof geometry !== 'object') return null;

  if (geometry.type === 'GeometryCollection') {
    return {
      ...geometry,
      geometries: (geometry.geometries || []).map(normalizeGeometry).filter(Boolean)
    };
  }

  const coordinates = normalizeCoordinates(geometry.coordinates);
  return coordinates ? { ...geometry, coordinates } : null;
};

export const normalizePreviewGeoJson = (value) => {
  if (!value) return null;

  let geoJson = value;
  if (typeof geoJson === 'string') {
    try { geoJson = JSON.parse(geoJson); } catch (error) { return null; }
  }

  if (geoJson.type === 'FeatureCollection') {
    return {
      ...geoJson,
      features: (geoJson.features || []).map(normalizePreviewGeoJson).filter(Boolean)
    };
  }

  if (geoJson.type === 'Feature') {
    const geometry = normalizeGeometry(geoJson.geometry);
    return geometry ? { ...geoJson, geometry } : null;
  }

  return normalizeGeometry(geoJson);
};
